import { API } from "revolt.js";
import styles from "./Attachment.module.scss";
import { useState } from "preact/hooks";

import { useClient } from "../../../../controllers/client/ClientController";
import { selectImageViewer } from "./image-modal.helper";
import ImageFile from "./ImageFile";

type Props = {
    attachment: API.File;
    allAttachments?: (API.File | API.Embed)[];
    width?: number;
    height?: number;
};

export default function GifFile({
    attachment,
    allAttachments,
    width,
    height,
}: Props) {
    const client = useClient();
    const [previewError, setPreviewError] = useState(false);
    const [revealed, setRevealed] = useState(false);
    const [loaded, setLoaded] = useState(false);

    if (previewError) {
        return (
            <ImageFile
                allAttachments={allAttachments}
                attachment={attachment}
            />
        );
    }

    const previewUrl = client.generatePreviewFileURL(attachment);
    const originalUrl = client.generateFileURL(attachment, undefined, true)!;

    return (
        <>
            <img
                src={previewUrl}
                alt={attachment.filename}
                loading="lazy"
                className={styles.image}
                width={width}
                height={height}
                style={{ display: revealed && loaded ? "none" : undefined }}
                onClick={() => setRevealed(true)}
                onError={() => setPreviewError(true)}
            />
            {revealed && (
                <img
                    src={originalUrl}
                    alt={attachment.filename}
                    loading="lazy"
                    className={styles.image}
                    width={width}
                    height={height}
                    style={{ visibility: loaded ? "visible" : "hidden" }}
                    ref={(img) => {
                        if (img?.complete && img.getAttribute("src"))
                            setLoaded(true);
                    }}
                    onLoad={() => setLoaded(true)}
                    onError={() => setPreviewError(true)}
                    onClick={() =>
                        selectImageViewer(allAttachments, attachment)
                    }
                />
            )}
        </>
    );
}
